export const NEW_STUDENT_ID = 0;
export const DEFAULT_PASSWORD_EXPIRE_TIME = process.env.DEFAULT_PASSWORD_EXPIRE_TIME || '900000';
export const LOCAL_STORAGE_STUDENTS_KEY = 'passportStudents';
